module.exports = __webpack_public_path__ + "assets/b87542048ebc2018f331d740af18a1ca.png";